export default __webpack_public_path__ + "static/media/facebook_icon.58ff5f32.png";